import { InjectionToken } from '@angular/core';
import { XpoBoardOptions } from './board-options.model';

export const XPO_BOARD_DEFAULT_OPTIONS = new InjectionToken<XpoBoardOptions>('XpoBoardDefaultOptions');
